import { ProductFilter } from "app/shared/model/ProductFilter";
import { ProductSelectionDisplayProps, ProductSelectionDisplay } from "app/pages/DiscountEditor/components/ProductSelection";
import { getProductMap, getSelectedProductMissingSchoolHints } from "app/pages/DiscountEditor/modules/ProductSelection";
import { connect } from "react-redux";
import { UnitsFilter } from "app/shared/model/ProductUnitFilter";

interface ConnectionProductSelectionDisplayProps {
    productFilter: ProductFilter
    unitsFilter?: UnitsFilter
}

function mapStateToProps(state: any, ownProps: ConnectionProductSelectionDisplayProps) : ProductSelectionDisplayProps {
    const productMap = getProductMap(state);
    return {
        productFilter: ownProps.productFilter,
        unitFilter: ownProps.unitsFilter,
        productMap,
        productOfferingHints: getSelectedProductMissingSchoolHints(state, ownProps.productFilter)
    }
}

export default connect(mapStateToProps)(ProductSelectionDisplay);

